import React, { Component, PropTypes } from 'react';
import TimePicker from 'rc-time-picker';
import ErrorField from '../ErrorField';
import moment from 'moment';
import Clock from '../../icons/Clock';

import 'rc-time-picker/assets/index.css';
import './TimeField.css';

class TimeField extends Component {
  constructor() {
    super();
    this.handleChange = this.handleChange.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
  }

  handleChange(value) {
		if (value) {
    	this.props.handleChange(value, this.props.field.name)
		}
  }

  handleFocus() {
    this.props.handleFocus(this.props.field.name)
  }

  handleBlur() {
    this.props.handleBlur(this.props.field.name)
  }

  render() {
    const { field } = this.props;
		let inputStyle = 'dateField__wrap ';
		let placeholderStyle = 'input__placeholder ';
		if (field.touched === true || field.value !== '') {
			placeholderStyle = placeholderStyle + 'input__touched ';
		}
		if (field.error && field.hasBlurred) {
			placeholderStyle = placeholderStyle + 'input__placeholder-error';
			inputStyle = inputStyle + 'input__border-error';
		} else if (!field.error && field.touched) {
			placeholderStyle = placeholderStyle + 'input__placeholder-success';
			inputStyle = inputStyle + 'input__border-success';
    }
    if (typeof(field.value) === 'string' && field.value !== '') {
      field.value = moment(field.value);
    }
    return (
				<div className="dateField">
					<TimePicker
						onChange={this.handleChange}
						showSecond={false}
						value={field.value}
						format="h:mm a"
						use12Hours
						className={inputStyle}/>
					<Clock/>
				<p className={placeholderStyle}>
					{field.placeholder}
				</p>
				<ErrorField hasBlurred={field.hasBlurred} error={field.error}/>
			</div>
    );
  }
}

TimeField.propTypes = {
  field: PropTypes.shape({
      value: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      error: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
      ]),
      placeholder: PropTypes.string.isRequired,
      hasBlurred: PropTypes.bool.isRequired,
      inputType: PropTypes.string.isRequired,
      breed: PropTypes.string.isRequired
    }),
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  handleFocus: PropTypes.func.isRequired
};

export default TimeField;



/** WEBPACK FOOTER **
 ** ./src/components/TimeField/index.js
 **/